import { render, staticRenderFns } from "./product-card.vue?vue&type=template&id=236274a0&"
import script from "./product-card.vue?vue&type=script&lang=ts&"
export * from "./product-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports